export const getSourceParam = () => {
  try {
    return new URLSearchParams(window.location.search).get('m')
  } catch (ErrorMessage) {
    return null
  }
}
